import { Controller } from "stimulus";

export default class extends Controller {
    // Action to trigger when the select element changes
    submit() {
        // This finds the form that contains the select element and submits it
        this.element.closest("form").requestSubmit();
    }
}